import { useState } from 'react';
import PropTypes from 'prop-types';

import checkGrayIcon from 'assets/check-gray.svg';
import copyChatIcon from 'assets/copy-chat.svg';

import copyValue from 'utlis/copy_value';

import styles from './styles.module.scss';

const CopyButton = ({ content }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyValue(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      className={styles['copy-button']}
      onClick={handleCopy}
    >
      <img
        src={copied ? checkGrayIcon : copyChatIcon}
        alt={copied ? 'Copied' : 'Copy'}
        className={styles['copy-icon']}
      />
    </button>
  );
};

CopyButton.propTypes = {
  content: PropTypes.string.isRequired,
};

export default CopyButton;
